const labelColor = '#1A1726'; // the button label color
export const theme = {
    textPrimary: '#1A1726', // main text color
    textSecondary: '#54535B', // secondary text color
    title: '#1A1726', // e.g. the passenger / place names in the drop down
    primary: '#1a1726', // primary button color
    secondary: '#EFEEF3', // secondary button color
    buttonBorderRadius: '0.25rem',
    buttonText: '#FFFFFF',
    alert: '#D9001A',
    seats: {
        // These represent the colors of the seats depending on the category
        1: {
            // STANDARD SEAT, Standard säte
            fill: '#EFEEF3', // the seat fill color
            stopColor: '#EFEEF3', // the gradient stop color for the seat fill
            labelColor,
            borderColor: '#FFFFFF', // the border color
        },
        2: {
            // PREFERRED SEAT, Föredraget säte
            fill: '#DAD9DE',
            stopColor: '#DAD9DE',
            labelColor,
            borderColor: '#FFFFFF',
        },
        3: {
            // SEAT WITH MORE SPACE, Säte med större plats
            fill: '#B4B2BB',
            stopColor: '#B4B2BB',
            labelColor,
            borderColor: '#FFFFFF',
        },
        4: {
            // SEAT WITH MORE SPACE, Säte med större plats
            fill: '#B4B2BB',
            stopColor: '#B4B2BB',
            labelColor,
            borderColor: '#FFFFFF',
        },
        5: {
            fill: '#B4B2BB',
            stopColor: '#B4B2BB',
            labelColor,
            borderColor: '#FFFFFF',
        },
        6: {
            fill: '#B4B2BB',
            stopColor: '#B4B2BB',
            labelColor,
            borderColor: '#FFFFFF',
        },
        not_available: {
            fill: '#EFEEF3', // color used for the bg of unavailable seats
            stopColor: '#EFEEF3',
            labelColor: '#B4B2BB',
            borderColor: '#86848E', // color used to draw the "X" on unavailable seats
        },
        selected_seat: {
            fill: '#302A47',
            stopColor: '#302A47',
            labelColor: '#FFFFFF',
            borderColor: '#FFFFFF',
        },
    },
};
